import { LockOutlined } from '@ant-design/icons'

const Lock = ({ ...props }) => {
  return <LockOutlined className="text-base cursor-pointer" {...props} />
}

export default Lock
